export function AnimatedGradient() {
  return (
    <div className="fixed inset-0 -z-10">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("https://images.pexels.com/photos/434337/pexels-photo-434337.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2")',
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/40 dark:bg-black/60" />

      {/* Animated Gradient */}
      <svg
        className="absolute inset-0 w-full h-full opacity-50"
        preserveAspectRatio="none"
        viewBox="0 0 1440 800"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop
              offset="0%"
              className="text-purple-700/30 dark:text-purple-500/30"
              style={{ stopColor: "currentColor" }}
            >
              <animate
                attributeName="stop-color"
                values="rgba(109,40,217,0.3);rgba(79,70,229,0.3);rgba(109,40,217,0.3)"
                dur="10s"
                repeatCount="indefinite"
              />
            </stop>
            <stop
              offset="100%"
              className="text-blue-700/30 dark:text-blue-500/30"
              style={{ stopColor: "currentColor" }}
            >
              <animate
                attributeName="stop-color"
                values="rgba(59,130,246,0.3);rgba(99,102,241,0.3);rgba(59,130,246,0.3)"
                dur="10s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8"
              result="goo"
            />
          </filter>
        </defs>
        <g filter="url(#goo)">
          <path
            fill="url(#gradient)"
            d="M 0,800 C 0,800 0,400 0,400 C 120.53333333333333,373.8666666666667 241.06666666666666,347.73333333333335 351,359 C 460.93333333333334,370.26666666666665 560.2666666666667,418.93333333333334 675,425 C 789.7333333333333,431.06666666666666 919.8666666666667,394.53333333333336 1037,380 C 1154.1333333333332,365.46666666666664 1258.2666666666667,372.93333333333334 1362.4,380.4 L 1440,388 L 1440,800 L 0,800 Z"
          >
            <animate
              attributeName="d"
              values="M 0,800 C 0,800 0,400 0,400 C 120.53333333333333,373.8666666666667 241.06666666666666,347.73333333333335 351,359 C 460.93333333333334,370.26666666666665 560.2666666666667,418.93333333333334 675,425 C 789.7333333333333,431.06666666666666 919.8666666666667,394.53333333333336 1037,380 C 1154.1333333333332,365.46666666666664 1258.2666666666667,372.93333333333334 1362.4,380.4 L 1440,388 L 1440,800 L 0,800 Z;
                     M 0,800 C 0,800 0,400 0,400 C 97.86666666666666,419.2 195.73333333333332,438.4 320,425 C 444.2666666666667,411.6 594.9333333333334,365.6 724,359 C 853.0666666666666,352.4 960.5333333333333,385.2 1076,397 C 1191.4666666666667,408.8 1314.9333333333334,399.6 1438.4,390.4 L 1440,388 L 1440,800 L 0,800 Z;
                     M 0,800 C 0,800 0,400 0,400 C 120.53333333333333,373.8666666666667 241.06666666666666,347.73333333333335 351,359 C 460.93333333333334,370.26666666666665 560.2666666666667,418.93333333333334 675,425 C 789.7333333333333,431.06666666666666 919.8666666666667,394.53333333333336 1037,380 C 1154.1333333333332,365.46666666666664 1258.2666666666667,372.93333333333334 1362.4,380.4 L 1440,388 L 1440,800 L 0,800 Z"
              dur="20s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </svg>
    </div>
  );
} 